export const newKey = () => window.crypto.randomUUID ? window.crypto.randomUUID() : '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, c => (c ^ window.crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
export const copy = value => JSON.parse(JSON.stringify(value));
export const statuses = { 0: 'آماده شروع', 1: 'در حال انجام', 2: 'در انتظار بررسی', 3: 'تأیید شده', 4: 'رد شده', 5: 'برگشت برای اصلاح', 6: 'متوقف' };
export function errorText(api, response) {
  if ([400, 409].includes(response.status) && response.data) {
    const flatten = value => typeof value === 'string' ? [value] : value && typeof value === 'object' ? Object.values(value).flatMap(flatten) : [];
    const messages = [...new Set(flatten(response.data))];
    if (messages.length) return messages.slice(0, 8).join('\n');
  }
  return api.getErrorMessage(response);
}
export function move(rows, index, direction) {
  const target = index + direction;
  if (target < 0 || target >= rows.length) return;
  rows.splice(target, 0, rows.splice(index, 1)[0]);
}
export function templatePayload(form) {
  const value = copy(form);
  ['id', 'revision', 'template_family', 'version', 'current_id', 'is_current', 'used', 'source'].forEach(k => delete value[k]);
  return value;
}

export const stepKinds = { question: 'پرسش و چک‌لیست', photo: 'عکس', instruction: 'راهنما و تأیید مطالعه', approval: 'تأیید مسئول', inventory: 'درخواست قطعه', equipment: 'بررسی تجهیزات نصب‌شده', file: 'فایل و مدرک', signature: 'امضا' };
export const artifactKind = kind => ['photo', 'file', 'signature'].includes(kind);
export function normalizeTemplate(form) {
  form.workflow = { enabled: false, sequential: true, allow_backtrack: true, publication: 'draft', ...form.workflow };
  (form.steps || []).forEach(s => {
    s.key = s.key || newKey(); s._key = s.key; s.questions = s.questions || [];
    s.config = { visible_when: { match: 'all', rules: [] }, max_file_mb: 10, file_types: ['pdf', 'jpg', 'png', 'webp'], allow_none: true, require_fulfilled: false, ...s.config };
    s.config.visible_when = { match: 'all', rules: [], ...s.config.visible_when };
    s.questions.forEach(q => {
      q.config = { control: 'default', placeholder: '', unit: '', image_url: '', visible_when: { match: 'all', rules: [] }, required_when: { match: 'all', rules: [] }, ...q.config };
      ['visible_when', 'required_when'].forEach(key => { q.config[key] = { match: 'all', rules: [], ...q.config[key] }; });
      Object.values(q.choices).forEach(cs => cs.forEach(c => { c.config = { key: newKey(), description: '', image_url: '', exclusive: false, requires_note: false, risk: '', ...c.config }; }));
    });
  });
  return form;
}
export function remapConditions(steps, map) {
  steps.forEach(s => {
    const conditions = [s.config.visible_when, ...s.questions.flatMap(q => [q.config.visible_when, q.config.required_when])];
    conditions.forEach(c => (c && c.rules || []).forEach(r => { r.question_key = map[r.question_key] || r.question_key; }));
  });
}
